export function CalendarLink(props) {
  return (
    <svg
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M8.5 5.75C8.09 5.75 7.75 5.41 7.75 5V2C7.75 1.59 8.09 1.25 8.5 1.25C8.91 1.25 9.25 1.59 9.25 2V5C9.25 5.41 8.91 5.75 8.5 5.75Z"
        fill="white"
      />
      <path
        d="M16.5 5.75C16.09 5.75 15.75 5.41 15.75 5V2C15.75 1.59 16.09 1.25 16.5 1.25C16.91 1.25 17.25 1.59 17.25 2V5C17.25 5.41 16.91 5.75 16.5 5.75Z"
        fill="white"
      />
      <path
        d="M9 14.5001C8.87 14.5001 8.74 14.4701 8.62 14.4201C8.49 14.3701 8.39 14.3001 8.29 14.2101C8.11 14.0201 8 13.7701 8 13.5001C8 13.3701 8.03 13.2401 8.08 13.1201C8.13 13.0001 8.2 12.8901 8.29 12.7901C8.39 12.7001 8.49 12.6301 8.62 12.5801C8.98 12.4301 9.43 12.5101 9.71 12.7901C9.89 12.9801 10 13.2401 10 13.5001C10 13.5601 9.99 13.6301 9.98 13.7001C9.97 13.7601 9.95 13.8201 9.92 13.8801C9.9 13.9401 9.87 14.0001 9.83 14.0601C9.8 14.1101 9.75 14.1601 9.71 14.2101C9.52 14.3901 9.26 14.5001 9 14.5001Z"
        fill="white"
      />
      <path
        d="M12.5 14.5C12.37 14.5 12.24 14.47 12.12 14.42C11.99 14.37 11.89 14.3 11.79 14.21C11.61 14.02 11.5 13.77 11.5 13.5C11.5 13.37 11.53 13.24 11.58 13.12C11.63 13 11.7 12.89 11.79 12.79C11.89 12.7 11.99 12.63 12.12 12.58C12.48 12.42 12.93 12.51 13.21 12.79C13.39 12.98 13.5 13.24 13.5 13.5C13.5 13.56 13.49 13.63 13.48 13.7C13.47 13.76 13.45 13.82 13.42 13.88C13.4 13.94 13.37 14 13.33 14.06C13.3 14.11 13.25 14.16 13.21 14.21C13.02 14.39 12.76 14.5 12.5 14.5Z"
        fill="white"
      />
      <path
        d="M16 14.5C15.87 14.5 15.74 14.47 15.62 14.42C15.49 14.37 15.39 14.3 15.29 14.21C15.25 14.16 15.21 14.11 15.17 14.06C15.13 14 15.1 13.94 15.08 13.88C15.05 13.82 15.03 13.76 15.02 13.7C15.01 13.63 15 13.56 15 13.5C15 13.24 15.11 12.98 15.29 12.79C15.39 12.7 15.49 12.63 15.62 12.58C15.99 12.42 16.43 12.51 16.71 12.79C16.89 12.98 17 13.24 17 13.5C17 13.56 16.99 13.63 16.98 13.7C16.97 13.76 16.95 13.82 16.92 13.88C16.9 13.94 16.87 14 16.83 14.06C16.8 14.11 16.75 14.16 16.71 14.21C16.52 14.39 16.26 14.5 16 14.5Z"
        fill="white"
      />
      <path
        d="M9 17.9999C8.87 17.9999 8.74 17.97 8.62 17.92C8.5 17.87 8.39 17.7999 8.29 17.7099C8.11 17.5199 8 17.2599 8 16.9999C8 16.8699 8.03 16.7399 8.08 16.6199C8.13 16.4899 8.2 16.38 8.29 16.29C8.66 15.92 9.34 15.92 9.71 16.29C9.89 16.48 10 16.7399 10 16.9999C10 17.2599 9.89 17.5199 9.71 17.7099C9.52 17.8899 9.26 17.9999 9 17.9999Z"
        fill="white"
      />
      <path
        d="M12.5 17.9999C12.24 17.9999 11.98 17.8899 11.79 17.7099C11.61 17.5199 11.5 17.2599 11.5 16.9999C11.5 16.8699 11.53 16.7399 11.58 16.6199C11.63 16.4899 11.7 16.38 11.79 16.29C12.16 15.92 12.84 15.92 13.21 16.29C13.3 16.38 13.37 16.4899 13.42 16.6199C13.47 16.7399 13.5 16.8699 13.5 16.9999C13.5 17.2599 13.39 17.5199 13.21 17.7099C13.02 17.8899 12.76 17.9999 12.5 17.9999Z"
        fill="white"
      />
      <path
        d="M16 18C15.74 18 15.48 17.89 15.29 17.71C15.2 17.62 15.13 17.51 15.08 17.38C15.03 17.26 15 17.13 15 17C15 16.87 15.03 16.74 15.08 16.62C15.13 16.49 15.2 16.38 15.29 16.29C15.52 16.06 15.87 15.95 16.19 16.02C16.26 16.03 16.32 16.05 16.38 16.08C16.44 16.1 16.5 16.13 16.56 16.17C16.61 16.2 16.66 16.25 16.71 16.29C16.89 16.48 17 16.74 17 17C17 17.26 16.89 17.52 16.71 17.71C16.52 17.89 16.26 18 16 18Z"
        fill="white"
      />
      <path
        d="M21 9.83997H4C3.59 9.83997 3.25 9.49997 3.25 9.08997C3.25 8.67997 3.59 8.33997 4 8.33997H21C21.41 8.33997 21.75 8.67997 21.75 9.08997C21.75 9.49997 21.41 9.83997 21 9.83997Z"
        fill="white"
      />
      <path
        d="M16.5 22.75H8.5C4.85 22.75 2.75 20.65 2.75 17V8.5C2.75 4.85 4.85 2.75 8.5 2.75H16.5C20.15 2.75 22.25 4.85 22.25 8.5V17C22.25 20.65 20.15 22.75 16.5 22.75ZM8.5 4.25C5.64 4.25 4.25 5.64 4.25 8.5V17C4.25 19.86 5.64 21.25 8.5 21.25H16.5C19.36 21.25 20.75 19.86 20.75 17V8.5C20.75 5.64 19.36 4.25 16.5 4.25H8.5Z"
        fill="white"
      />
    </svg>
  );
}

export function BadgesLink(props) {
  return (
    <svg
      viewBox="0 0 64 64"
      fill="white"
      stroke="white"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-label="Trophy"
      {...props}
    >
      {/* Cup */}
      <path d="M20 10h24v10c0 10-6 18-12 18s-12-8-12-18V10z"/>
      {/* Handles */}
      <path d="M20 14H12c0 10 6 16 12 18" fill="none"/>
      <path d="M44 14h8c0 10-6 16-12 18" fill="none"/>
      {/* Stem */}
      <line x1="32" y1="38" x2="32" y2="48"/>
      {/* Base */}
      <rect x="22" y="48" width="20" height="6"/>
    </svg>
  );
}

export function VideosLink(props) {
  return (
    <svg
      {...props}
      viewBox="0 0 46 46"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <circle
        cx="23"
        cy="23"
        r="21"
        fill="#5690b1"
      />
      <polygon
        points="17,12 32,23 17,34"
        fill="white"
        stroke="white"
        stroke-width="3"
        stroke-linejoin="round"
      />
    </svg>
  );
}

export function CollectionLink(props) {
  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.22 22.75H9.83007C9.19007 22.75 8.63005 22.71 8.12005 22.64C7.71005 22.58 7.42003 22.2 7.48003 21.79C7.54003 21.38 7.91007 21.08 8.33007 21.15C8.77007 21.21 9.26006 21.24 9.82006 21.24H15.2101C19.3001 21.24 20.7501 19.79 20.7501 15.7V11.21C20.7501 10.8 21.0901 10.46 21.5001 10.46C21.9101 10.46 22.2501 10.8 22.2501 11.21V15.7C22.2601 20.64 20.15 22.75 15.22 22.75Z"
        fill="white"
      />
      <path
        d="M3.54004 16.27C3.13004 16.27 2.79004 15.93 2.79004 15.52V11.22C2.79004 10.81 3.13004 10.47 3.54004 10.47C3.95004 10.47 4.29004 10.81 4.29004 11.22V15.52C4.29004 15.93 3.95004 16.27 3.54004 16.27Z"
        fill="white"
      />
      <path
        d="M12.5298 12.75C11.4298 12.75 10.4298 12.32 9.71978 11.53C9.00978 10.74 8.67979 9.70999 8.78979 8.60999L9.45983 1.93005C9.49983 1.55005 9.81983 1.25 10.2098 1.25H14.8798C15.2698 1.25 15.5898 1.54005 15.6298 1.93005L16.2998 8.60999C16.4098 9.70999 16.0798 10.74 15.3698 11.53C14.6298 12.32 13.6298 12.75 12.5298 12.75ZM10.8698 2.75L10.2698 8.76001C10.1998 9.43001 10.3998 10.06 10.8198 10.52C11.6698 11.46 13.3698 11.46 14.2198 10.52C14.6398 10.05 14.8398 9.42001 14.7698 8.76001L14.1698 2.75H10.8698Z"
        fill="white"
      />
      <path
        d="M18.83 12.75C16.8 12.75 14.99 11.11 14.78 9.08997L14.08 2.07996C14.06 1.86996 14.13 1.66 14.27 1.5C14.41 1.34 14.61 1.25 14.83 1.25H17.88C20.82 1.25 22.19 2.48 22.6 5.5L22.88 8.28003C23 9.46003 22.64 10.5801 21.87 11.4301C21.1 12.2801 20.02 12.75 18.83 12.75ZM15.66 2.75L16.28 8.93994C16.41 10.1899 17.58 11.25 18.83 11.25C19.59 11.25 20.27 10.9601 20.76 10.4301C21.24 9.90005 21.46 9.19005 21.39 8.43005L21.11 5.68005C20.8 3.42005 20.07 2.75 17.88 2.75H15.66Z"
        fill="white"
      />
      <path
        d="M6.16979 12.75C4.97979 12.75 3.89982 12.2801 3.12982 11.4301C2.35982 10.5801 1.99981 9.46003 2.11981 8.28003L2.39984 5.53003C2.81984 2.48003 4.18982 1.25 7.12982 1.25H10.1798C10.3898 1.25 10.5898 1.34 10.7398 1.5C10.8798 1.66 10.9498 1.86996 10.9298 2.07996L10.2298 9.08997C10.0098 11.11 8.18979 12.75 6.16979 12.75ZM7.11981 2.75C4.92981 2.75 4.19982 3.40995 3.87982 5.69995L3.6098 8.42004C3.5298 9.18004 3.7598 9.89004 4.2398 10.42C4.7198 10.95 5.40979 11.24 6.16979 11.24C7.42979 11.24 8.59978 10.1801 8.71978 8.93005L9.33984 2.73999H7.11981V2.75Z"
        fill="white"
      />
      <path
        d="M5.5 23.75C4.1 23.75 2.79001 23.1399 1.89001 22.0699C1.88001 22.0599 1.84 22.02 1.81 21.97C1.66 21.79 1.52999 21.61 1.42999 21.42C0.989993 20.71 0.75 19.87 0.75 18.99C0.75 17.53 1.40003 16.18 2.53003 15.28C2.73003 15.12 2.95 14.97 3.19 14.84C3.88 14.45 4.69 14.23 5.5 14.23C6.66 14.23 7.73003 14.63 8.59003 15.38C8.70003 15.46 8.84998 15.61 8.97998 15.75C9.78998 16.64 10.24 17.78 10.24 18.97C10.24 19.84 9.99999 20.69 9.54999 21.42C9.32999 21.8 9.06001 22.13 8.76001 22.39C8.70001 22.45 8.64001 22.5101 8.57001 22.5601C7.78001 23.3301 6.67 23.75 5.5 23.75ZM2.97998 21.04C3.00998 21.07 3.05998 21.1199 3.09998 21.1899C3.64998 21.8399 4.55 22.26 5.5 22.26C6.29 22.26 7.05 21.97 7.63 21.45C7.66001 21.41 7.7 21.37 7.75 21.34C7.95 21.17 8.12003 20.9499 8.28003 20.6899C8.59003 20.1799 8.76001 19.61 8.76001 19.01C8.76001 18.2 8.45001 17.41 7.89001 16.8C7.82001 16.72 7.74997 16.64 7.65997 16.58C6.57997 15.65 5.09998 15.5101 3.91998 16.1801C3.75998 16.2701 3.61999 16.36 3.48999 16.47C2.70999 17.09 2.26001 18.01 2.26001 19.01C2.26001 19.6 2.41998 20.1801 2.72998 20.6801C2.80998 20.8201 2.88998 20.93 2.97998 21.03C2.96998 21.03 2.97998 21.03 2.97998 21.04Z"
        fill="white"
      />
      <path
        d="M6.99976 19.73H4.00977C3.59977 19.73 3.25977 19.39 3.25977 18.98C3.25977 18.57 3.59977 18.23 4.00977 18.23H6.99976C7.40976 18.23 7.74976 18.57 7.74976 18.98C7.74976 19.39 7.40976 19.73 6.99976 19.73Z"
        fill="white"
      />
      <path
        d="M5.5 21.26C5.09 21.26 4.75 20.92 4.75 20.51V17.52C4.75 17.11 5.09 16.77 5.5 16.77C5.91 16.77 6.25 17.11 6.25 17.52V20.51C6.25 20.93 5.91 21.26 5.5 21.26Z"
        fill="white"
      />
    </svg>
  );
}

export function ProfileLink(props) {
  return (
    <svg
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.12 13.53C12.1 13.53 12.07 13.53 12.05 13.53C12.02 13.53 11.98 13.53 11.95 13.53C9.68 13.46 7.97998 11.69 7.97998 9.50998C7.97998 7.28998 9.79 5.47998 12.01 5.47998C14.23 5.47998 16.04 7.28998 16.04 9.50998C16.03 11.7 14.32 13.46 12.15 13.53C12.13 13.53 12.13 13.53 12.12 13.53ZM12 6.96998C10.6 6.96998 9.46998 8.10998 9.46998 9.49998C9.46998 10.87 10.54 11.98 11.9 12.03C11.93 12.02 12.03 12.02 12.13 12.03C13.47 11.96 14.52 10.86 14.53 9.49998C14.53 8.10998 13.4 6.96998 12 6.96998Z"
        fill="white"
      />
      <path
        d="M12.0001 22.7499C9.31008 22.7499 6.74008 21.7499 4.75008 19.9299C4.57008 19.7699 4.49008 19.5299 4.51008 19.2999C4.64008 18.1099 5.38008 16.9999 6.61008 16.1799C9.59008 14.1999 14.4201 14.1999 17.3901 16.1799C18.6201 17.0099 19.3601 18.1099 19.4901 19.2999C19.5201 19.5399 19.4301 19.7699 19.2501 19.9299C17.2601 21.7499 14.6901 22.7499 12.0001 22.7499ZM6.08008 19.0999C7.74008 20.4899 9.83008 21.2499 12.0001 21.2499C14.1701 21.2499 16.2601 20.4899 17.9201 19.0999C17.7401 18.4899 17.2601 17.8999 16.5501 17.4199C14.0901 15.7799 9.92008 15.7799 7.44008 17.4199C6.73008 17.8999 6.26008 18.4899 6.08008 19.0999Z"
        fill="white"
      />
      <path
        d="M12 22.75C6.07 22.75 1.25 17.93 1.25 12C1.25 6.07 6.07 1.25 12 1.25C17.93 1.25 22.75 6.07 22.75 12C22.75 17.93 17.93 22.75 12 22.75ZM12 2.75C6.9 2.75 2.75 6.9 2.75 12C2.75 17.1 6.9 21.25 12 21.25C17.1 21.25 21.25 17.1 21.25 12C21.25 6.9 17.1 2.75 12 2.75Z"
        fill="white"
      />
    </svg>
  );
}

export function FacebookLink(props) {
  return (
    <svg
      {...props}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 2.25C6.34 2.25 1.75 6.84 1.75 12.5C1.75 17.58 5.48 21.82 10.34 22.63V15.47H7.75V12.5H10.34V10.25C10.34 7.69 11.89 6.25 14.23 6.25C15.37 6.25 16.56 6.45 16.56 6.45V8.97H15.25C13.96 8.97 13.56 9.77 13.56 10.59V12.5H16.44L15.98 15.47H13.56V22.63C18.42 21.82 22.15 17.58 22.15 12.5C22.15 6.84 17.56 2.25 12 2.25Z"
        fill="white"
      />
    </svg>
  );
}

